import React from 'react';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { MainContent } from './MainContent';
import { CommandPalette } from '../shared/CommandPalette';
import { useSidebar } from '../../hooks/useSidebar';
import { useCommandPalette } from '../../hooks/useCommandPalette';
import { useKeyboardShortcuts } from '../../hooks/useKeyboardShortcuts';

interface AppShellProps {
  children: React.ReactNode;
  onCalendarChange?: () => void;
  use24HourFormat?: boolean;
  onTimeFormatToggle?: () => void;
  setUse24HourFormat?: (value: boolean) => void;
  selectedCities?: any[];
  onAddCity?: (city: any) => void;
  getLocalizedCityName?: (city: any) => string;
  onToggleHelp?: () => void;
  onOpenCalendarPreferences?: () => void;
  onOpenTimezoneGroups?: () => void;
  onLoadGroup?: (groupId: string) => void;
  hasChanges?: boolean;
  onOpenCommandPalette?: () => void;
}

export function AppShell({ children, onCalendarChange, use24HourFormat, onTimeFormatToggle, setUse24HourFormat, selectedCities, onAddCity, getLocalizedCityName, onToggleHelp, onOpenCalendarPreferences, onOpenTimezoneGroups, onLoadGroup, hasChanges = false, onOpenCommandPalette }: AppShellProps) {
  const sidebar = useSidebar();
  const commandPalette = useCommandPalette();

  useKeyboardShortcuts({
    onCommandPalette: onOpenCommandPalette || commandPalette.toggle,
    onToggleSidebar: sidebar.toggle,
  });

  return (
    <div className="min-h-screen bg-background">
      <Header 
        onToggleSidebar={sidebar.toggle}
        onOpenCommandPalette={commandPalette.open}
        onCalendarChange={onCalendarChange}
        onLoadGroup={onLoadGroup}
        hasChanges={hasChanges}
      />
      <div className="flex">
        <Sidebar 
          isCollapsed={sidebar.isCollapsed}
          onToggle={sidebar.toggle}
          use24HourFormat={use24HourFormat}
          onTimeFormatToggle={onTimeFormatToggle}
          setUse24HourFormat={setUse24HourFormat}
          onOpenCommandPalette={commandPalette.open}
          onToggleHelp={onToggleHelp}
          onOpenCalendarPreferences={onOpenCalendarPreferences}
          onOpenTimezoneGroups={onOpenTimezoneGroups}
        />
        <MainContent 
          isCollapsed={sidebar.isCollapsed}
          onCloseSidebar={() => {
            if (!sidebar.isCollapsed) {
              sidebar.toggle();
            }
          }}
        >
          {children}
        </MainContent>
      </div>
      <CommandPalette 
        isOpen={commandPalette.isOpen}
        onClose={commandPalette.close}
        selectedCities={selectedCities}
        onAddCity={onAddCity}
        getLocalizedCityName={getLocalizedCityName}
      />
    </div>
  );
}